<script setup lang="ts">
import { calculateStyle } from "@/pages/Cms/CmsPage/configuration"
import type { Ref } from "vue"
import { inject } from "vue"
import { getHref, getTarget } from "./link-service"

const props = withDefaults(
    defineProps<{
        class: any
        element: any
    }>(),
    {
        class: null,
        element: null,
    },
)

const collapseStates =
    props.element.config.buttonLink === "_collapse" ? inject<Ref<Record<string, boolean>>>("collapseStates") : null

const toggleCollapse = (): void => {
    if (collapseStates) {
        const collapseId = props.element.config.selectedCollapseId

        // Ensure the key exists before toggling
        if (!(collapseId in collapseStates.value)) {
            collapseStates.value[collapseId] = false
        }

        collapseStates.value[collapseId] = !collapseStates.value[collapseId]
    }
}
</script>

<template>
    <button
        :class="props.class"
        :style="calculateStyle(element)"
        @click="toggleCollapse"
        v-if="element.config.buttonLink === '_collapse'"
    >
        {{ element.buttonText || element.title }}
    </button>
    <a
        :href="getHref(element)"
        :class="props.class"
        :target="getTarget(element)"
        :style="calculateStyle(element)"
        v-else
    >
        {{ element.buttonText || element.title }}
        <slot></slot>
    </a>
</template>
